import {enqueueSnackbar, VariantType} from 'notistack';
import {toastConfig} from '../config/toastConfig';

const safeEnqueue = (message: string, variant: VariantType) => {
    try {
        const duration = toastConfig.duration[variant as keyof typeof toastConfig.duration] || toastConfig.duration.default;
        enqueueSnackbar(message, {variant, autoHideDuration: duration});
    } catch {
        // Fallback when SnackbarProvider is not mounted (e.g., in tests)
        console.warn(`[toast.${variant}] ${message}`);
    }
};

export const toast = {
    success: (message: string) => safeEnqueue(message, 'success'),
    error: (message: string) => safeEnqueue(message, 'error'),
    warning: (message: string) => safeEnqueue(message, 'warning'),
    info: (message: string) => safeEnqueue(message, 'info'),
    show: (message: string, variant: VariantType = 'default') => safeEnqueue(message, variant),
};
